import React from "react";
import { ChatIcon, BookOpenIcon, VideoIcon, ChevronRightIcon } from "./HelpCenterIcons";

const ACTIONS = [
  {
    label: "Contact Support",
    desc: "Get help from our team",
    icon: ChatIcon,
    iconColor: "#eb1414",
    iconBg: "#fef2f2",
  },
  {
    label: "View Documentation",
    desc: "Read detailed guides",
    icon: BookOpenIcon,
    iconColor: "#3b82f6",
    iconBg: "#eff6ff",
  },
  {
    label: "Watch Tutorials",
    desc: "Learn with video guides",
    icon: VideoIcon,
    iconColor: "#22c55e",
    iconBg: "#dcfce7",
  },
];

const HelpCenterQuickActions = () => {
  return (
    <div className="v2-help-pg__quick-actions">
      {ACTIONS.map((action) => {
        const Icon = action.icon;
        return (
          <button className="v2-help-pg-quick" key={action.label}>
            <div className="v2-help-pg-quick__left">
              <div
                className="v2-help-pg-quick__icon"
                style={{ background: action.iconBg }}
              >
                <Icon size={22} color={action.iconColor} />
              </div>
              <div className="v2-help-pg-quick__text">
                <span className="v2-help-pg-quick__label">{action.label}</span>
                <span className="v2-help-pg-quick__desc">{action.desc}</span>
              </div>
            </div>
            <ChevronRightIcon size={18} color="#9ca3af" />
          </button>
        );
      })}
    </div>
  );
};

export default HelpCenterQuickActions;
